module.exports = __webpack_public_path__ + "static/media/MY-NEWERA.92736c0a.png";